// src/components/home/ImageGallery.jsx
import React from "react";

const ImageGallery = ({ images = [] }) => {
  const validImages =
    Array.isArray(images) && images.length > 0
      ? images.filter((image) => image?.url)
      : [];

  if (validImages.length === 0) {
    return null;
  }

  const renderImage = (image, index, keyPrefix) => {
    const altText = image.alternativeText || `Gallery image ${index + 1}`;

    return (
      <div
        key={`${keyPrefix}-${image.id ?? index}`}
        className="homepage-image-marquee__item flex shrink-0 items-center justify-center px-2"
      >
        <img
          src={image.url}
          alt={altText}
          className="h-48 sm:h-56 md:h-64 lg:h-72 w-auto max-w-none object-contain"
          draggable={false}
        />
      </div>
    );
  };

  return (
    <section className="bg-transparent">
      <div className="w-full py-2 sm:py-4">
        <div className="homepage-image-marquee overflow-hidden px-2 sm:px-4 md:px-8">
          <div className="homepage-image-marquee__track flex w-max">
            {validImages.map((image, index) =>
              renderImage(image, index, "a")
            )}
            {validImages.map((image, index) =>
              renderImage(image, index, "b")
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;
